import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import LanguagesState from '../types/LanguagesState'

const mutations: MutationTree<LanguagesState> = {
  [types.CHANGES_LANGUAGE] (state, language) {
    state.currentLanguage = language
  }
}

export default mutations
